import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import env from "../config/env";

dayjs.extend(relativeTime);

export const formatDate = (timestamp, format = "DD MMM YYYY HH:mm") => {
  if (!timestamp) return "-";
  return dayjs(timestamp * 1000).format(format);
};

export const formatRelativeTime = (timestamp) => {
  if (!timestamp) return "-";
  return dayjs(timestamp * 1000).startOf("minute").fromNow();
};

export const getKolkataUnixSeconds = () => {
  const now = new Date();
  const kolkataTime = new Date(
    now.toLocaleString("en-US", { timeZone: env.timezone })
  );
  return Math.floor(kolkataTime.getTime() / 1000);
};

export const isOverdue = (dueDateUnix) => {
  if (!dueDateUnix) return false;
  return dueDateUnix < getKolkataUnixSeconds();
};

export const isDueSoon = (dueDateUnix, withinDays = 3) => {
  if (!dueDateUnix) return false;
  const now = getKolkataUnixSeconds();
  const withinSeconds = withinDays * 24 * 60 * 60;
  return dueDateUnix >= now && dueDateUnix - now <= withinSeconds;
};
